module.exports = __webpack_public_path__ + "Bliss2-BoldItalic.5943394571138ecefe79.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-BoldItalic.woff2
// module id = ../../../../../src/assets/layout/fonts/Bliss2-BoldItalic.woff2
// module chunks = styles